<template>
    <div id="whatsappcontactlist">
        <div class="my-1 wp-list-searching-input">
            <span style="display: flex; align-items: center">
                <b-button @click="refresh" class="m-2" :disabled="refreshAllow">{{ $t("message.refresh") }}</b-button>
                <a-input-search
                    v-model="searchText"
                    :placeholder="$t('message.search')"
                    class="search-input"
                    @input="onSearch($event.target.value)"
                />
                <multiselect
                    style="width: 300px; height: 30px"
                    v-model="selectedChannelName"
                    :multiple="true"
                    :options="channels"
                    :placeholder="$t('message.allChannels')"
                    :label="channelMultiselectLabel"
                    track-by="name"
                    :select-label="''"
                >
                </multiselect>
            </span>
            <span class="mr-5">
                <!--                <a-button @click="showModal">-->
                <!--                    {{ $t("wp.startChatWithAnyNo") }}-->
                <!--                </a-button>-->
                <a-modal
                    :title="$t('wp.typeInANumberDesc')"
                    :visible="visible"
                    :confirm-loading="confirmLoading"
                    @ok="handleOk(wpContactNumber)"
                    @cancel="handleCancel"
                    class="row d-flex flex-row"
                >
                    <div v-if="showAlertMessage" class="pb-3">
                        <a-alert :message="$t('wp.toLittleChar')" type="error" banner />
                    </div>
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <vue-country-code
                            class="col-3 country-code"
                            :enabledCountryCode="true"
                            @onSelect="onSelect($event)"
                            :defaultCountry="userLastCountry"
                        />
                        <div class="col-8">
                            <a-input
                                v-model="wpContactNumber"
                                :placeholder="$t('message.phone')"
                                autocomplete="off"
                                trim
                                type="text"
                                v-mask="'##########'"
                            />
                        </div>
                    </div>
                </a-modal>
            </span>
        </div>
        <a-table
            :columns="cols"
            :dataSource="filterContactListData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            :key="'vtable-' + renderCount"
            :locale="{
                emptyText: $t('message.noContactFound'),
            }"
            rowKey="id"
            size="small"
            class="custom-table"
        >
            <div slot="avatarSlot" slot-scope="data, item" class="p-1">
                <a-avatar
                    :size="30"
                    shape="square"
                    style="background-color: #3899ff; border-radius: 7px !important"
                    :username="item.name"
                    :src="$_.get(item, 'profilePicThumbObj.eurl')"
                >
                    {{ !!item.name ? item.name.substr(0, 1).toLocaleUpperCase() : "" }}
                </a-avatar>
            </div>
            <div slot="action" slot-scope="data, item">
                <div class="d-flex justify-content-end" style="margin-right: -10px !important">
                    <md-button
                        id="joinChat"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                        }"
                        :content="$t('wp.startChatWp')"
                        data-v-step="16"
                        @click="startChat(item)"
                    >
                        {{ $t("wp.startChatWp") }}
                        <md-icon style="color: #06e576; font-size: 12px"> whatsapp</md-icon>
                    </md-button>
                    <button
                        class="delete-chat"
                        id="deleteChat"
                        :content="$t('message.deletePerson')"
                        data-v-step="16"
                        @click="deleteVisitorConfirm(item)"
                    >
                        <span class="material-icons">close</span>
                    </button>
                </div>
            </div>
        </a-table>
    </div>
</template>

<script>
import { log2 } from "../utils/log2";
import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { tableSorter } from "../utils/utils";
import Fuse from "fuse.js";
import { filter, first, timeout } from "rxjs/operators";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import VueTheMask from "vue-the-mask";
import _ from "lodash";
import Multiselect from "vue-multiselect";
import ChatWatcher from "../ChatWatcherV2";

Vue.use(VueTheMask);
Vue.use(VueCountryCode);

const log = log2("WhatsappContactListV2");
export default {
    name: "WhatsappContactListV2",
    components: { VueCountryCode, Multiselect },
    props: {},
    data() {
        return {
            channelMultiselectLabel: "name",
            visible: false,
            confirmLoading: false,
            internationalCallingCode: "90",
            wpContactNumber: "",
            showAlertMessage: false,
            searchText: "",
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                current: 1,
                total: 0,
                defaultPageSize: 10,
                pageSizeOptions: ["10", "15", "20", "50", "100"],
                showQuickJumper: true,
                showSizeChanger: true,
            },
            cols: [
                {
                    key: "profilePicThumbObj",
                    dataIndex: "profilePicThumbObj.eurl",
                    title: this.$t("message.profile"),
                    ...tableSorter("profilePicThumbObj", "string", this.currentSort),
                    scopedSlots: { customRender: "avatarSlot" },
                },
                {
                    key: "name",
                    dataIndex: "name",
                    title: this.$t("message.name"),
                    ...tableSorter("name", "string", this.currentSort),
                    scopedSlots: { customRender: "name" },
                },
                {
                    key: "phoneNumber",
                    dataIndex: `phoneNumber`,
                    title: this.$t("message.number"),
                    ...tableSorter("phoneNumber", "string", this.currentSort),
                    scopedSlots: { customRender: "phoneNumber" },
                },
                {
                    key: "channelName",
                    dataIndex: `channelName`,
                    title: this.$t("whatsappChannel.channelName"),
                    ...tableSorter("channelName", "string", this.currentSort),
                    scopedSlots: { customRender: "channelName" },
                },
                {
                    title: this.$t("wp.action"),
                    key: "operation",
                    scopedSlots: { customRender: "action" },
                    width: "100px",
                },
            ],
            loading: true,
            refreshAllow: false,
            contactListData: [],
            filterContactListData: [],
            selectedChannelName: [],
        };
    },
    computed: {
        ...mapState({
            channels: (state) =>
                state.channel.channels.filter(
                    (x) => x.type === "whatsapp-qr" || x.type === "whatsapp-v2" || x.type === "whatsapp-business-api" || x.type === "whatsapp-business-api-supsis"
                ),
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            contacts: (state) => state.whatsapp.allContacts,
            totalContacts: (state) => state.whatsapp.allContactsTotal,
            searchingResultsOfWpContact: (state) => state.whatsapp.searchingResultsOfWpContact,
            whatsappPlusActive: (state) => _.get(state.setting.settings, "whatsapp.plus.enabled", false),
            wpInfo: (state) => state.whatsapp.info.initialized,
            channelInfo: (state) => state.whatsapp.channelInfo,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            myActiveConversations: "chat/getMyActiveConversations",
            whatsappServiceIsHealthy: "whatsapp/isHealthy",
            whatsappEnabled: (state) =>
                _.get(state.settings, "whatsapp.enabled", false) ||
                _.get(state.settings, "whatsapp.plus.enabled", false),
        }),
    },
    async mounted() {
        this.pagination.total = this.totalContacts;
        if (this.channels.length === 0) await this.listChannels();
        await this.sendGetContactMessage();
        this.filterContactListData = this.contacts;
        this.loading = false;
    },
    watch: {
        selectedChannelName(nV, oV) {
            if (nV.length === 0) {
                this.filterContactListData = this.contacts;
            } else {
                const filterValues = nV.map((x) => x.name);
                this.filterContactListData = this.contacts.filter((x) => filterValues.includes(x.channelName));
            }
        },
    },
    methods: {
        ...mapActions({
            getContactList: "chat/getContactList",
            listChannels: "channel/listChannels",
            deleteVisitor: "visitor/deleteVisitor",
        }),
        ...mapMutations({
            setSearchingResultWPContact: "whatsapp/setSearchingResultWPContact",
            setAllContacts: "whatsapp/setAllContacts",
            deleteContact: "whatsapp/deleteContact",
        }),
        async sendGetContactMessage() {
            const allContacts = await this.getContactList({
                pageCount: this.pagination.current,
                perPage: this.pagination.pageSize || this.pagination.defaultPageSize || 10,
                searchValue: this.searchText,
            });
            const whatsappContacts = allContacts.result.map((x) => {
                x.channelName = !!x.channel ? x.channel.name : "-";
                x.name = !!x.fullname ? x.fullname : "-";
                x.phoneNumber = !!x.whatsappNumber ? x.whatsappNumber : "-";
                return x;
            });
            this.pagination.total = allContacts.totalResult;
            this.setAllContacts({
                whatsappContacts,
                whatsappContactsTotal: allContacts.totalResult,
            });
            this.loading = false;
            this.filterContactListData = this.contacts;
        },
        deleteVisitorConfirm(item) {
            this.$confirm({
                title: "Kişiyi sil",
                content: "Kişiyi slimek istediğinizden emin misiniz?",
                okText: "Sil",
                okType: "danger",
                cancelText: "Kapat",
                onOk: async () => {
                    this.refreshAllow = true;
                    await this.deleteVisitor(item._id)
                        .then((res) => {
                            this.$message.destroy();
                            this.$message.success("Konuşma silindi");
                            this.filterContactListData = this.filterContactListData.filter((x) => x._id !== item._id);
                            this.deleteContact(item._id);
                        })
                        .finally(() => {
                            this.refreshAllow = false;
                        });
                },
            });
        },
        startChat(item) {
            if (
                (!!item.channel && !this.channelInfo[item.channel._id]) ||
                (!!item.channel &&
                    !!this.channelInfo[item.channel._id] &&
                    this.channelInfo[item.channel._id].status.status.STATE !== "CONNECTED")
            ) {
                return this.$message.error("Whatsapp servisi aktif değil.");
            } else if (item.channel === null && !this.whatsappServiceIsHealthy) {
                return this.$message.error("Whatsapp servisi aktif değil.");
            } else if (item.channelName === "-" && !this.whatsappServiceIsHealthy) {
                return this.$message.error("Whatsapp servisi aktif değil.");
            }
            item.phoneNumber = item.phoneNumber.includes("@c.us") ? item.phoneNumber : item.phoneNumber + "@c.us";

            ChatWatcher.startChatImmediately({
                whatsappNumber: item.phoneNumber,
                channelId: !!item.channel ? _.get(item.channel, "_id") : null,
            });
        },
        refresh: _.debounce(function () {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            this.pagination.current = 1;
            this.sendGetContactMessage();
        }, 400),
        handleTableChange(pagination, filters, sorter) {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 370);
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.sendGetContactMessage();
        },
        getFilteredRows(getContacts = this.contacts) {
            log("getFilteredRows before", getContacts);
            let fuzzySearch = new Fuse(getContacts, { keys: ["name", "phoneNumber"] });
            const filteredRows =
                this.searchText.length > 0 ? fuzzySearch.search(this.searchText).map((x) => x.item) : getContacts;
            log("filteredRow after", filteredRows);
            return filteredRows;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            // this.filterContactListData = this.contacts.filter(
            //     (x) => x.name.toLowerCase().includes(value.toLowerCase()) || x.phoneNumber.includes(value)
            // );
            this.refresh();
        },
        onSelect(value) {
            log("onSelect", value);
            this.internationalCallingCode = value.dialCode;
        },
        showModal() {
            this.visible = true;
        },
        handleOk(number) {
            this.wpContactNumber = number.replace(/[{()}]/g, "");
            const contactNumber = this.internationalCallingCode + this.wpContactNumber;

            if (contactNumber.length < 6) {
                this.showAlertMessage = true;
                return;
            }
            this.confirmLoading = true;
            this.showAlertMessage = false;
            this.visible = false;
            this.confirmLoading = false;

            const searchedContacts = JSON.parse(JSON.stringify(this.searchingResultsOfWpContact));
            const isNumberExistInSearchHistory = searchedContacts[number];
            if (isNumberExistInSearchHistory !== undefined) {
                this.readyToChatStartingControl(isNumberExistInSearchHistory);
            } else {
                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "whatsapp_contacts_is_includes_number"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        let searchingResultWPContact = {};
                        const isExist = _.get(x, "data.contactIsExist") || false;
                        searchingResultWPContact[`${number}`] = isExist;
                        this.readyToChatStartingControl(isExist);
                        this.setSearchingResultWPContact(searchingResultWPContact);
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    });

                sendSocketMessage("whatsapp number-is-exist-in-contacts", {
                    siteId: this.site._id,
                    searchingPhoneNumber: contactNumber,
                    channelId: null,
                });
            }
        },
        readyToChatStartingControl(isExist) {
            if (isExist) {
                this.startChat({ phoneNumber: this.internationalCallingCode + this.wpContactNumber });
            } else if (this.whatsappPlusActive) {
                this.startChat({ phoneNumber: this.internationalCallingCode + this.wpContactNumber });
            } else {
                this.controlWhatsappPlusIntegration();
            }
        },
        handleCancel(e) {
            this.visible = false;
            this.showAlertMessage = false;
        },
        openNotificationWithIcon(featureType, type = "warning") {
            const messages = {
                wpPlusAndLicenceRequired: {
                    message: this.$t("wp.wpPlusAndLicenceRequired"),
                    description: `${this.$t("wp.wpPlusAndLicenceRequiredDesc")} `,
                },
            };
            const message = messages[featureType];
            const key = `plan`;
            this.$notification[type]({
                message: message.message,
                description: message.description,
                placement: "topRight",
                onClose: () => this.$router.push("/chat?tab=whatsappContacts"),
                key,
                btn: (h) => {
                    let buttonText = !this.whatsappPlusActive
                        ? this.$t("message.changePlan")
                        : this.$t("message.close");
                    return h(
                        "a-button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    if (featureType === "wpPlusAndLicenceRequired") this.$router.push("/settings/billing");

                                    this.$notification.close(key);
                                },
                            },
                        },
                        buttonText
                    );
                },
            });
        },
        controlWhatsappPlusIntegration() {
            if (!this.whatsappPlusActive) {
                this.openNotificationWithIcon("wpPlusAndLicenceRequired");
            }
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.delete-chat {
    background: none;
    border: none;
    margin-right: 5px;

    &:hover {
        background-color: #c0bfbf;
        border-radius: 10px;
    }
}

.custom-button {
    max-width: 18px;
    min-width: 18px;
    max-height: 18px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-button svg {
    width: 14px;
    height: 14px;
}

.custom-table {
    background-color: #ffffff;
    border-radius: 6px;
    padding: 10px 20px;
    overflow-y: auto;
}

#joinChat {
    font-size: 12px;
    border-radius: 4px;
    border: solid 1px #92e317;
    background-color: white;

    &:hover {
        border: solid 2px #92e317;
    }
}

.wp-list-searching-input {
    margin: 5px 5px !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.inputs {
    border: 1px solid #e5e5e5;
    position: relative;
    border-radius: 6px;
    -webkit-box-shadow: 0 0 1px #00000080;
    box-shadow: 0 0 1px #00000080;
}
</style>
